import {
    MAX_RECEIPT_FILE_SIZE,
    MIN_RECEIPT_FILE_SIZE,
    RECEIPT_FILE_COUNT_ERROR,
    RECEIPT_FILE_SIZE_ERROR,
    RECEIPT_FILE_TYPE_ERROR,
    RECEIPT_MIME_TYPE,
} from './constants';

export const validateReceiptFiles = (files: readonly File[]): string | null => {
    if (files.length !== 1) {
        return RECEIPT_FILE_COUNT_ERROR;
    }

    const file = files[0];
    const hasPdfMimeType = file.type === RECEIPT_MIME_TYPE;
    const hasPdfExtensionWithoutMimeType = file.type === '' && /\.pdf$/i.test(file.name);

    if (!hasPdfMimeType && !hasPdfExtensionWithoutMimeType) {
        return RECEIPT_FILE_TYPE_ERROR;
    }

    if (file.size < MIN_RECEIPT_FILE_SIZE || file.size > MAX_RECEIPT_FILE_SIZE) {
        return RECEIPT_FILE_SIZE_ERROR;
    }

    return null;
};
